module.exports = __webpack_public_path__ + "static/media/3ddocs_green.737e8d0e.png";